import React, { ReactNode } from "react";

import { Anchor } from "@newsela/angelou";
import Head from "next/head";

import ErrorMessage from "../ErrorMessage";
import { errorPageCss } from "./ErrorPage.style";
import HomePageLinkButton from "./HomePageLinkButton";

interface ErrorPageProps {
  title?: string;
  children?: ReactNode;
}

interface ParentComposition {
  HomePageLinkButton?: typeof HomePageLinkButton;
}

const ErrorPage: React.FC<ErrorPageProps> & ParentComposition = ({
  title = "Newsela | Error",
  children = (
    <ErrorMessage headline="Uh-oh. Our fault." illustration={null}>
      <p>Looks like something went wrong and we're working fast to fix it.</p>
      <div>
        <HomePageLinkButton>Back to Homepage</HomePageLinkButton>
      </div>
      <p>
        Contact us at{" "}
        <Anchor isInline href="https://support.newsela.com/contact">
          support.newsela.com/contact
        </Anchor>{" "}
        if you have questions.
      </p>
    </ErrorMessage>
  ),
}: ErrorPageProps) => {
  return (
    <div css={errorPageCss}>
      <Head>
        <title>{title}</title>
      </Head>
      {children}
    </div>
  );
};

ErrorPage.HomePageLinkButton = HomePageLinkButton;

export default ErrorPage;
